import { useMemo } from "react";
import { useFetchPostV2 } from "hooks/fetch/useFetchPostV2";

export function usePostRule() {
  const url = useMemo(() => `rules/`, []);

  const { loading, error, data, postCallback } = useFetchPostV2(url);

  return { loading, error, data, postRuleCallback: postCallback };
}
